(function () {
  'use strict';

  var sectionSelector = '.template-product [data-ui-component="Main Product Section"]';
  var slideshowSelector = 'ecx-prd-slideshow';
  var mobileArrowSelector = '.sw-product-gallery__arrow';
  var desktopArrowSelector = '.pagination-thumbnail__horizontal .js-carousel-prev-btn, .pagination-thumbnail__horizontal .js-carousel-next-btn';
  var navSelector = mobileArrowSelector + ', ' + desktopArrowSelector;

  function getProductSections(root) {
    var scope = root && root.querySelectorAll ? root : document;

    if (scope.matches && scope.matches(sectionSelector)) {
      return [scope];
    }

    return Array.prototype.slice.call(scope.querySelectorAll(sectionSelector));
  }

  function getMediaTargets(slideshow) {
    return Array.prototype.slice.call(slideshow.querySelectorAll('.js-slideshow-btn-thumb[data-target]'))
      .map(function (button) {
        return button.dataset.target;
      })
      .filter(function (target, index, targets) {
        return target && targets.indexOf(target) === index;
      });
  }

  function getActiveTarget(slideshow) {
    var activeThumb = slideshow.querySelector('.js-product-slideshow-thumb.is-active-item[data-media-target-id]');

    if (activeThumb && activeThumb.dataset.mediaTargetId) {
      return activeThumb.dataset.mediaTargetId;
    }

    return getDisplayedTarget(slideshow);
  }

  // Source of truth for the image actually on screen, independent of base Blum's
  // is-active-item (which it only keeps on the thumbnail set the user clicked, so it
  // drifts off the visible row after arrow nav). The visible main slide always tracks
  // the displayed media, so we key the Seaweed highlight off it instead.
  function getDisplayedTarget(slideshow) {
    var activeItem = slideshow.querySelector('.js-product-slideshow-item.d-block[data-media-id]:not(.d-none)') || slideshow.querySelector('.js-product-slideshow-item[data-media-id]:not(.d-none)');

    return activeItem ? activeItem.dataset.mediaId : '';
  }

  function syncActiveThumb(slideshow) {
    var target = getDisplayedTarget(slideshow);
    var changed = target !== slideshow.swLastThumbTarget;
    slideshow.swLastThumbTarget = target;

    Array.prototype.forEach.call(slideshow.querySelectorAll('.js-product-slideshow-thumb[data-media-target-id]'), function (thumb) {
      var isActive = !!target && thumb.dataset.mediaTargetId === target;
      thumb.classList.toggle('sw-thumb-active', isActive);

      // Only scroll when the displayed image actually changed, so the strip doesn't
      // re-center on every unrelated class mutation the observer sees.
      if (isActive && changed) {
        keepThumbInView(thumb);
      }
    });
  }

  // Center the active thumbnail in its scrollable strip so it is never clipped at the
  // edge or hidden behind the carousel arrows when a product has more media than fits.
  function keepThumbInView(thumb) {
    var strip = thumb.closest('.js-carousel-items') || thumb.parentElement;

    if (!strip || strip.scrollWidth <= strip.clientWidth + 2) {
      return;
    }

    var stripRect = strip.getBoundingClientRect();

    if (stripRect.width === 0) {
      return; // hidden thumbnail layout (e.g. vertical set on desktop)
    }

    var thumbRect = thumb.getBoundingClientRect();
    var delta = (thumbRect.left - stripRect.left) - (strip.clientWidth - thumbRect.width) / 2;
    var maxLeft = strip.scrollWidth - strip.clientWidth;
    var targetLeft = Math.max(0, Math.min(strip.scrollLeft + delta, maxLeft));

    if (Math.abs(targetLeft - strip.scrollLeft) > 1) {
      var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      strip.scrollTo({ left: targetLeft, behavior: reduceMotion ? 'auto' : 'smooth' });
    }
  }

  function observeSlideshow(slideshow) {
    if (slideshow.swThumbObserver) {
      return;
    }

    var scheduled = false;
    var observer = new MutationObserver(function () {
      if (scheduled) {
        return;
      }

      scheduled = true;
      window.requestAnimationFrame(function () {
        scheduled = false;
        syncActiveThumb(slideshow);
      });
    });

    // The main slides toggle d-none/d-block as media changes; watching class on the
    // subtree catches every navigation path (Seaweed arrows, base arrows, swipe,
    // direct thumbnail click, variant change). toggle() is idempotent so our own
    // sw-thumb-active writes settle without looping.
    observer.observe(slideshow, { attributes: true, attributeFilter: ['class'], subtree: true });
    slideshow.swThumbObserver = observer;
  }

  function getActiveIndex(slideshow, targets) {
    var activeTarget = getActiveTarget(slideshow);
    var activeIndex = targets.indexOf(activeTarget);

    return activeIndex >= 0 ? activeIndex : 0;
  }

  function updateCounters(slideshow, index) {
    Array.prototype.forEach.call(slideshow.querySelectorAll('.js-carousel-counter-current'), function (counter) {
      counter.textContent = String(index + 1);
    });
  }

  function updateDisabledState(slideshow) {
    var targets = getMediaTargets(slideshow);
    var activeIndex = getActiveIndex(slideshow, targets);
    var isFirst = activeIndex <= 0;
    var isLast = activeIndex >= targets.length - 1;

    Array.prototype.forEach.call(slideshow.querySelectorAll(navSelector), function (button) {
      var isPrevious = button.classList.contains('js-carousel-prev-btn') || button.name === 'previous';
      var isNext = button.classList.contains('js-carousel-next-btn') || button.name === 'next';

      if (isPrevious) {
        button.disabled = isFirst;
        button.setAttribute('aria-disabled', String(isFirst));
      }

      if (isNext) {
        button.disabled = isLast;
        button.setAttribute('aria-disabled', String(isLast));
      }
    });

    updateCounters(slideshow, activeIndex);
    syncActiveThumb(slideshow);
  }

  function selectMedia(slideshow, index) {
    var targets = getMediaTargets(slideshow);
    var target = targets[index];
    var thumbButton;

    if (!target) {
      updateDisabledState(slideshow);
      return;
    }

    if (window.CSS && window.CSS.escape) {
      thumbButton = slideshow.querySelector('.js-slideshow-btn-thumb[data-target="' + window.CSS.escape(target) + '"]');
    } else {
      thumbButton = Array.prototype.slice.call(slideshow.querySelectorAll('.js-slideshow-btn-thumb[data-target]')).find(function (button) {
        return button.dataset.target === target;
      });
    }

    if (!thumbButton) {
      updateDisabledState(slideshow);
      return;
    }

    thumbButton.click();

    // Centering of the active thumb is handled by syncActiveThumb (via updateDisabledState)
    // once the displayed slide updates, so it works for every navigation path uniformly.
    window.requestAnimationFrame(function () {
      updateDisabledState(slideshow);
    });
  }

  function handleNavigationClick(event) {
    var button = event.target.closest(navSelector);

    if (!button) {
      return;
    }

    var section = button.closest(sectionSelector);
    var slideshow = button.closest(slideshowSelector);

    if (!section || !slideshow || !section.contains(slideshow)) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    var targets = getMediaTargets(slideshow);
    var activeIndex = getActiveIndex(slideshow, targets);
    var direction = button.name === 'previous' || button.classList.contains('js-carousel-prev-btn') && !button.classList.contains('js-carousel-next-btn') ? -1 : 1;
    var nextIndex = Math.max(0, Math.min(targets.length - 1, activeIndex + direction));

    if (nextIndex !== activeIndex) {
      selectMedia(slideshow, nextIndex);
    } else {
      updateDisabledState(slideshow);
    }
  }

  function handleThumbnailClick(event) {
    var button = event.target.closest('.js-slideshow-btn-thumb[data-target]');

    if (!button) {
      return;
    }
    var section = button.closest(sectionSelector);
    var slideshow = button.closest(slideshowSelector);

    if (!section || !slideshow || !section.contains(slideshow)) {
      return;
    }

    window.requestAnimationFrame(function () {
      updateDisabledState(slideshow);
    });
  }

  function initProductGallery(root) {
    getProductSections(root).forEach(function (section) {
      Array.prototype.forEach.call(section.querySelectorAll(slideshowSelector), function (slideshow) {
        observeSlideshow(slideshow);
        updateDisabledState(slideshow);
      });
    });
  }

  function initWhenReady() {
    initProductGallery(document);
  }

  document.addEventListener('click', handleNavigationClick, true);
  document.addEventListener('click', handleThumbnailClick);
  document.addEventListener('shopify:section:load', function (event) {
    initProductGallery(event.target);
  });
  document.addEventListener('page:loaded', initWhenReady);
  window.addEventListener('load', initWhenReady);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initWhenReady);
  } else {
    initWhenReady();
  }
})();
